import { snakeCase, upperCase } from "lodash";

export enum TypePersonalAccount {
	RMP_ENTERPRISE_APP = "RMP-ENTERPRISE-APP",
	RMP_COUNTERPARTY_APP = "RMP-COUNTERPARTY-APP",
}

export const getTypePersonalAccount = () => {
	return TypePersonalAccount[snakeCase(process.env.VUE_APP_OIDC_CLIENT_ID ?? "").toUpperCase() as keyof typeof TypePersonalAccount];
};
